import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type { FieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const timeseriesFields: FieldInterface[] = [
  {
    key: 'timeseries',
    originKey: 'timeseries',
    objectType: 'PortfolioTimeSeries',
    objectTypePath: 'src/global-types',
    type: FIELD_TYPES.object,
    isMultiple: true,
  },
  {
    key: 'fromDate',
    originKey: 'from_date',
    type: FIELD_TYPES.date,
  },
  {
    key: 'toDate',
    originKey: 'to_date',
    type: FIELD_TYPES.date,
  },
]
